module.exports = __webpack_public_path__ + "static/media/step6.e75eb739.png";